var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDocumentIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 67.496,
    height: 88.61,
    viewBox: "0 0 67.496 88.61",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "document_2_",
    "data-name": "document (2)",
    transform: "translate(-61)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25809",
    "data-name": "Group 25809"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36742",
    "data-name": "Path 36742",
    d: "M125.519,18.391,108.831,2.6A9.482,9.482,0,0,0,102.29,0H70.519A9.529,9.529,0,0,0,61,9.519V79.092a9.529,9.529,0,0,0,9.519,9.519h48.459a9.529,9.529,0,0,0,9.519-9.519V25.306A9.558,9.558,0,0,0,125.519,18.391Zm-5.043,2.377H107.555a.866.866,0,0,1-.865-.865V7.725Zm-1.5,62.65H70.519a4.332,4.332,0,0,1-4.327-4.327V9.519a4.332,4.332,0,0,1,4.327-4.327H101.5V19.9a6.064,6.064,0,0,0,6.057,6.057H123.3V79.092A4.332,4.332,0,0,1,118.977,83.418Z",
    fill: "#3d3d3d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36743",
    "data-name": "Path 36743",
    d: "M168.671,200H130.6a2.6,2.6,0,1,0,0,5.192h38.075a2.6,2.6,0,1,0,0-5.192Z",
    transform: "translate(-55.404 -165.387)",
    fill: "#3d3d3d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36744",
    "data-name": "Path 36744",
    d: "M168.671,280H130.6a2.6,2.6,0,0,0,0,5.192h38.075a2.6,2.6,0,0,0,0-5.192Z",
    transform: "translate(-55.404 -231.542)",
    fill: "#3d3d3d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36745",
    "data-name": "Path 36745",
    d: "M143.181,360H130.6a2.6,2.6,0,0,0,0,5.192h12.585a2.6,2.6,0,0,0,0-5.192Z",
    transform: "translate(-55.404 -297.696)",
    fill: "#3d3d3d"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentIcon);
export default __webpack_public_path__ + "static/media/documentIcon.378cd86021d41b3a6619f3097167ee10.svg";
export { ForwardRef as ReactComponent };